import React from "react";
import { Row } from "antd";

const Membership = () => {
    return (
        <Row justify='center'>
            <h1>Hey whats up bro this is the Membership component</h1>
        </Row>
    )
}

export default Membership;